import { useOnMount } from "./index";
import { useLocation } from "react-router-dom";
import TagManager from "react-gtm-module";

const useGtmPageEvent = () => {
  const location = useLocation();
  const tagManagerArgs = {
    dataLayer: {
      pageUrl: location.pathname,
    },
  };
  useOnMount(() => {
    TagManager.dataLayer(tagManagerArgs);
  });
};

export default useGtmPageEvent;